// ======================================================================
// File Name       : SuperuserServiceRoleRegisterEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { superuserServiceRoleEdit } from '../../actions/SuperuserServiceRoleAction';
import FormControlValidate from '../../components/FormControlValidate';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import AboutRoleDialog from '../../components/superuserServiceRole/AboutRoleDialog';
import RoleManagementFunctionDisplay from '../../components/superuserServiceRole/RoleManagementFunctionDisplay';
import RoleManagementFunction from '../../components/superuserServiceRole/RoleManagementFunction';
import RoleRegisterEditConfirm from '../../components/superuserServiceRole/RoleRegisterEditConfirm';
import {
  AUTHORITY_PRESET_DEFAULT,
  MANAGEMENT_AUTHORITY_DISPLAY_TYPE,
  MANAGEMENT_AUTHORITY_TYPE,
  SCORING_MANAGEMENT_AUTHORITY_TYPE,
} from '../../constants/AuthorityConstant';
import * as Path from '../../constants/PathConstants';
import { AUTHORITY } from '../../constants/PathConstants';
import { MODAL_SIZE, MODE, USAGE_SETTING } from '../../constants/index';

class SuperuserServiceRoleRegisterEditContainer extends React.Component {
  /**
   * The constructor of component
   * @param {*} props
   */
  constructor(props) {
    super(props);
    this.authorityDefault = {
      superuserServiceRoleSecernId: '',
      managementFunctionAuthorityInfo: {
        userManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        groupManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        courseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        contentManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        achievementManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        scoringManagementAuthority: SCORING_MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        messageManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        noticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        emailManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        liveManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        userfrontManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        performanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        authorityManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        materialManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
      },
      managementFunctionAuthorityDisplayInfo: {
        userManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        groupManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        courseManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        contentManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        achievementManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        scoringManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        messageManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        noticeManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        emailManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        liveManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        userfrontManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        performanceManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        authorityManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        materialManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
      },
    };
    this.state = {
      mode: MODE.NEW_MODE,
      authority: { ...this.authorityDefault },
      defaultChecked: AUTHORITY_PRESET_DEFAULT.DEFAULT,
      showModalConfirm: false,
      showAboutDialog: false,
    };
    this.handleAuthorityChange = this.handleAuthorityChange.bind(this);
    this.handleManagementFunctionAuthorityChange = this.handleManagementFunctionAuthorityChange.bind(this);
    this.handleDefaultPresetChange = this.handleDefaultPresetChange.bind(this);
    this.openRegistUpdateConfirmDialog = this.openRegistUpdateConfirmDialog.bind(this);
    this.onRegistUpdateOk = this.onRegistUpdateOk.bind(this);
    this.onRegistUpdateCancel = this.onRegistUpdateCancel.bind(this);
    this.openAuthorityAboutDialog = this.openAuthorityAboutDialog.bind(this);
    this.onAuthorityAboutOk = this.onAuthorityAboutOk.bind(this);
    this.handleManagementFunctionAuthorityDisplayChange =
      this.handleManagementFunctionAuthorityDisplayChange.bind(this);
    this.getManagementFuntionAuthorityDefaultPreset = this.getManagementFuntionAuthorityDefaultPreset.bind(this);
    this.backPage = this.backPage.bind(this);
  }

  /**
   * Life cycle function of component
   */
  componentWillMount() {
    const {
      superuserServiceRole: { authorityInfo },
      match,
      history,
      authed,
    } = this.props;
    const { roleList } = authorityInfo;
    for (const curr of roleList) {
      if (match.params.id && curr.superuserServiceRoleSecernId === match.params.id) {
        this.setState({
          mode: MODE.EDIT_MODE,
          authority: curr,
        });
      }
    }
  }

  /**
   * Life cycle function
   */
  componentWillReceiveProps(nextProps) {
    const { superuserServiceRole, match } = nextProps;
    if (superuserServiceRole) {
      const { roleList } = superuserServiceRole;
      if (!roleList) return;
      for (const curr of roleList) {
        if (match.params.id && curr.superuserServiceRoleSecernId === match.params.id) {
          this.setState({
            mode: MODE.EDIT_MODE,
            authority: curr,
          });
        }
      }
    }
  }

  /**
   * Open dialog regist update confirm dialog
   */
  openRegistUpdateConfirmDialog() {
    let isValid = true;
    isValid = Object.keys(this.refsToValidate).every(
      (ref) => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation()
    );
    if (isValid) {
      this.setState({ showModalConfirm: true });
    }
  }

  /**
   * Event click button ok in confirm dialog
   */
  onRegistUpdateOk() {
    this.setState({
      showModalConfirm: false,
    });
    const { authority, mode } = this.state;
    const param = {
      editType: mode,
      roleInfo: { ...authority },
    };

    const targetAuthority = { ...authority };
    const { managementFunctionAuthorityDisplayInfo, managementFunctionAuthorityInfo } = targetAuthority;
    if (param.roleInfo && param.roleInfo.managementFunctionAuthorityDisplayInfo) {
      // check in 画面表示 is 表示 or 非表示, in case of 非表示, set 0 as default value
      const resultManagementAuthorityInfo = Object.keys(managementFunctionAuthorityDisplayInfo).reduce((acc, cur) => {
        const targetName = cur.replace("Display", "");
        acc[targetName] =
          managementFunctionAuthorityDisplayInfo[cur] > 0 ? managementFunctionAuthorityInfo[targetName] : 0;
        return acc;
      }, {});
      param.roleInfo.managementFunctionAuthorityInfo = resultManagementAuthorityInfo;

      // delete in param to make sure not send in request
      delete param.roleInfo.managementFunctionAuthorityDisplayInfo;
    }
    const { history } = this.props;
    this.props.dispatch(superuserServiceRoleEdit(param)).then(() => {
      //  Back to superuser role list
      history.push(Path.SUPERUSER_SERVICE_ROLE_LIST);
    });
  }

  /**
   * Event click button cancel in confirm dialog
   */
  onRegistUpdateCancel() {
    this.setState({
      showModalConfirm: false,
    });
  }

  getManagementFuntionAuthorityDefaultPreset(value) {
    let managementFunctionAuthorityInfo = "";
    switch (value) {
      case AUTHORITY_PRESET_DEFAULT.DEFAULT:
        managementFunctionAuthorityInfo = {
          userManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          groupManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          courseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          contentManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          achievementManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          scoringManagementAuthority: SCORING_MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          messageManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          noticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          emailManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          liveManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          userfrontManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          performanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          authorityManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          materialManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        };
        break;
      case AUTHORITY_PRESET_DEFAULT.ADMIN:
        managementFunctionAuthorityInfo = {
          userManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          groupManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          courseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          contentManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          achievementManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          scoringManagementAuthority: SCORING_MANAGEMENT_AUTHORITY_TYPE.SCORING_APPROVAL,
          messageManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          noticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          emailManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          liveManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          userfrontManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          performanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          authorityManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED, // STEP 11.0.0
          materialManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
        };
        break;
      case AUTHORITY_PRESET_DEFAULT.TEACHER:
        managementFunctionAuthorityInfo = {
          userManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          groupManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          courseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          contentManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          achievementManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          scoringManagementAuthority: SCORING_MANAGEMENT_AUTHORITY_TYPE.SCORING,
          messageManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          noticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          emailManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          liveManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          userfrontManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          performanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          authorityManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          materialManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
        };
        break;
      case AUTHORITY_PRESET_DEFAULT.SCORER:
        managementFunctionAuthorityInfo = {
          userManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          groupManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          courseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          contentManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          achievementManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          scoringManagementAuthority: SCORING_MANAGEMENT_AUTHORITY_TYPE.SCORING,
          messageManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          noticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          emailManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          liveManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          userfrontManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          performanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          authorityManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          materialManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        };
        break;
      default:
        break;
    }
    return managementFunctionAuthorityInfo;
  }

  /**
   * Event select radio button preset default
   * @param {*} event
   */
  handleDefaultPresetChange(event) {
    const value = parseInt(event.target.value, 10);
    const authority = { ...this.state.authority };

    authority.managementFunctionAuthorityInfo = this.getManagementFuntionAuthorityDefaultPreset(value);
    const authorityDisplayMapping = Object.keys(authority.managementFunctionAuthorityInfo).reduce((acc, cur) => {
      acc[`${cur}Display`] =
        authority.managementFunctionAuthorityInfo[cur] > 0
          ? MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
          : MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE;
      return acc;
    }, {});

    authority.managementFunctionAuthorityDisplayInfo = {
      ...authorityDisplayMapping,
    };

    this.setState({
      authority,
      defaultChecked: value,
    });
  }

  /**
   * Handle change authority name
   * @param {*} event
   */
  handleAuthorityChange(event) {
    const { name, value } = event.target;
    const { authority } = this.state;
    authority[name] = value;
    this.setState({ authority });
  }

  /**
   * Handle change radio button function authority
   * @param {*} event
   */
  handleManagementFunctionAuthorityChange(event) {
    const { name, value } = event.target;
    const { authority } = this.state;
    authority.managementFunctionAuthorityInfo[name] = parseInt(value, 10);
    this.setState({ authority });
  }

  handleManagementFunctionAuthorityDisplayChange(event) {
    const { name, value } = event.target;
    const { authority } = this.state;
    const targetValue = parseInt(value, 10);
    authority.managementFunctionAuthorityDisplayInfo[name] = targetValue;

    // set selected value if user change 非表示 to 表示
    if (targetValue === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY) {
      const targetAuthorityPermission = name.replace('Display', '');
      let authorityTargetValue = '';
      if (
        targetAuthorityPermission === 'materialManagementAuthority' ||
        targetAuthorityPermission === 'achievementManagementAuthority' ||
        targetAuthorityPermission === 'performanceManagementAuthority'
      ) {
        authorityTargetValue = MANAGEMENT_AUTHORITY_TYPE.REFERENCE;
      } else {
        authorityTargetValue = MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT;
      }
      authority.managementFunctionAuthorityInfo[targetAuthorityPermission] = authorityTargetValue;
    }
    this.setState({ authority });
  }

  /**
   * Show more information when click
   */
  openAuthorityAboutDialog() {
    this.setState({ showAboutDialog: true });
  }

  onAuthorityAboutOk() {
    this.setState({ showAboutDialog: false });
  }

  backPage() {
    this.props.history.goBack();
  }

  /**
   * Render function of component
   */
  render() {
    const isNewMode = this.state.mode === MODE.NEW_MODE;
    const {
      superuserServiceRoleSecernId,
      superuserServiceRoleName,
      managementFunctionAuthorityInfo,
      managementFunctionAuthorityDisplayInfo,
    } = this.state.authority;
    this.refsToValidate = [];
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.SUPERUSER_SERVICE_ROLE_LIST}
          text="サービスロール一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name={isNewMode ? 'サービスロールの追加' : `サービスロールの編集 - ${superuserServiceRoleName}`} />
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.openRegistUpdateConfirmDialog();
          }}
          className='form-horizontal'
          style={{ display: 'flow-root' }}
        >
          <Form.Group className="margin-top-10">
            <Col sm={7}>
              <h4>{isNewMode ? '登録する項目を指定してください。' : '編集する項目を指定してください。'}</h4>
            </Col>
            <Col sm={5}>
              <a className="link" onClick={this.openAuthorityAboutDialog}>
                <u className="cursor_pointer">各管理画面の権限ロールについて</u>
              </a>
            </Col>
            <Col sm={12} as={Form.Label} className="margin-top-10 ps-0">
              <h4>プリセットを元に編集することも可能です。</h4>
            </Col>
          </Form.Group>
          <Col className="padding-right-15">
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                プリセット
              </Col>
              <Col sm={2} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="なし"
                  id="authority-default-0"
                  value={0}
                  checked={this.state.defaultChecked === AUTHORITY_PRESET_DEFAULT.DEFAULT}
                  onChange={this.handleDefaultPresetChange}
                  label='なし'></Form.Check>
              </Col>
              <Col sm={2} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="管理者"
                  id="authority-default-1"
                  value={1}
                  checked={this.state.defaultChecked === AUTHORITY_PRESET_DEFAULT.ADMIN}
                  onChange={this.handleDefaultPresetChange}
                  label='管理者'></Form.Check>
              </Col>
              <Col sm={2} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="講師"
                  id="authority-default-2"
                  value={2}
                  checked={this.state.defaultChecked === AUTHORITY_PRESET_DEFAULT.TEACHER}
                  onChange={this.handleDefaultPresetChange}
                  label='講師'></Form.Check>
              </Col>
              <Col sm={2} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="採点者"
                  id="authority-default-3"
                  value={3}
                  checked={this.state.defaultChecked === AUTHORITY_PRESET_DEFAULT.SCORER}
                  onChange={this.handleDefaultPresetChange}
                  label='採点者'></Form.Check>
              </Col>
            </Form.Group>

            <hr className="break-line margin-top-10 margin-left-right-15" />
            <hr className="break-line margin-bottom-10 margin-left-right-15" />

            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                サービスロール名<span className="required">&nbsp;(※)</span>
              </Col>
              <Col sm={7}>
                <FormControlValidate
                  label="サービスロール名"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required
                  name="superuserServiceRoleName"
                  value={superuserServiceRoleName}
                  onChange={this.handleAuthorityChange}
                  type="text"
                  maxLength="64"
                />
              </Col>
            </Form.Group>

            <Form.Group>
              <Col sm={12} className="padding-bottom-10 margin-left-15">
                <p>画面表示</p>
              </Col>
              <Col sm={12} className="padding-left-50">
                <Form.Group>
                  <Col sm={12}>
                    <RoleManagementFunctionDisplay
                      label="受講ユーザー管理"
                      name="userManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.userManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="ユーザーグループ設定"
                      name="groupManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.groupManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="コース"
                      name="courseManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.courseManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="ビデオ/ドキュメント/リンク/ドリル"
                      name="contentManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.contentManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="学習履歴"
                      name="achievementManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.achievementManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="添削管理"
                      name="scoringManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.scoringManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="メッセージ管理"
                      name="messageManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.messageManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="お知らせ"
                      name="noticeManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.noticeManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="メール連絡"
                      name="emailManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.emailManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="受講ユーザー画面設定"
                      name="userfrontManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.userfrontManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="システム利用実績管理"
                      name="performanceManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.performanceManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <RoleManagementFunctionDisplay
                      label="TOP画面ダウンロードボタン"
                      name="materialManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.materialManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
            <Form.Group>
              <Col sm={12} className="padding-bottom-10 margin-left-15 margin-top-20">
                <p>権限設定</p>
              </Col>
              <Col sm={12} className="padding-left-50">
                <Form.Group>
                  <Col sm={12}>
                    <RoleManagementFunction
                      label="受講ユーザー管理"
                      name="userManagementAuthority"
                      value={managementFunctionAuthorityInfo.userManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.userManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="ユーザーグループ設定"
                      name="groupManagementAuthority"
                      value={managementFunctionAuthorityInfo.groupManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.groupManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="コース"
                      name="courseManagementAuthority"
                      value={managementFunctionAuthorityInfo.courseManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.courseManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="ビデオ/ドキュメント/リンク/ドリル"
                      name="contentManagementAuthority"
                      value={managementFunctionAuthorityInfo.contentManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.contentManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="学習履歴"
                      name="achievementManagementAuthority"
                      value={managementFunctionAuthorityInfo.achievementManagementAuthority}
                      notRegisterEdit
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.achievementManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="添削管理"
                      name="scoringManagementAuthority"
                      value={managementFunctionAuthorityInfo.scoringManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.scoringManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="メッセージ管理"
                      name="messageManagementAuthority"
                      value={managementFunctionAuthorityInfo.messageManagementAuthority}
                      notReference
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.messageManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="お知らせ"
                      name="noticeManagementAuthority"
                      value={managementFunctionAuthorityInfo.noticeManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.noticeManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="メール連絡"
                      name="emailManagementAuthority"
                      value={managementFunctionAuthorityInfo.emailManagementAuthority}
                      notReference
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.emailManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="受講ユーザー画面設定"
                      name="userfrontManagementAuthority"
                      value={managementFunctionAuthorityInfo.userfrontManagementAuthority}
                      notReference
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.userfrontManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <RoleManagementFunction
                      label="システム利用実績管理"
                      name="performanceManagementAuthority"
                      value={managementFunctionAuthorityInfo.performanceManagementAuthority}
                      notRegisterEdit
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.performanceManagementAuthorityDisplay ===
                        MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                      }
                    />
                    <Form.Group className="form-info">
                      <Col sm={3} as={Form.Label}>
                        TOP画面ダウンロードボタン
                      </Col>
                      <Col lg={5} sm={3} className="padding-top-10">
                        <Form.Check
                          type='radio'
                          inline
                          className="padding-top-clear"
                          name="materialManagementAuthority"
                          id={`materialManagementAuthority-${MANAGEMENT_AUTHORITY_TYPE.REFERENCE}`}
                          value={MANAGEMENT_AUTHORITY_TYPE.REFERENCE}
                          checked={
                            managementFunctionAuthorityInfo.materialManagementAuthority ===
                            MANAGEMENT_AUTHORITY_TYPE.REFERENCE
                          }
                          onChange={this.handleManagementFunctionAuthorityChange}
                          disabled={
                            managementFunctionAuthorityDisplayInfo.materialManagementAuthorityDisplay ===
                            MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE
                          }
                          label='ダウンロード可'></Form.Check>
                      </Col>
                    </Form.Group>
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
            <Form.Group className="margin-top-50 text-center">
              <Col sm={12} className="text-center">
                {!isNewMode && (
                  <Button variant="default" className="btn btn-default btn-96" role="button" onClick={this.backPage.bind(this)}>
                    キャンセル
                  </Button>
                )}
                <Button variant="primary" className="margin-left-10 margin-left-10 btn-96" type="submit">
                  OK
                </Button>
              </Col>
            </Form.Group>
          </Col>
        </Form>
        <RoleRegisterEditConfirm
          showModal={this.state.showModalConfirm}
          size={MODAL_SIZE.lg}
          authority={this.state.authority}
          onRegisterEditOk={this.onRegistUpdateOk}
          onRegisterEditCancel={this.onRegistUpdateCancel}
        />
        <AboutRoleDialog showModal={this.state.showAboutDialog} onAuthorityAboutOk={this.onAuthorityAboutOk} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ superuserServiceRole: state.superuserServiceRole, authed: state.authed },
});

export default connect(mapStateToProps)(SuperuserServiceRoleRegisterEditContainer);
